<template>
	<svg :width="width" :height="height" viewBox="0 0 272 44" role="presentation" xmlns="http://www.w3.org/2000/svg">
		<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g id="footer-2" transform="translate(-406.000000, -139.000000)">
				<path
					d="M418.311199,140.662958 L467.069977,139.069181 C468.480796,139.023065 469.892433,139.006827 471.30394,139.020477 L666.35544,140.906732 C671.850153,140.959869 676.430279,145.127675 677,150.59303 C677.665003,156.972423 677.690954,163.402298 677.077465,169.78685 L677,170.59303 C676.429877,176.526285 671.506624,181.092149 665.547294,181.214361 L599.77936,182.563107 L599.77936,182.563107 L417.782791,181.079735 C412.213592,181.034343 407.569285,176.808339 407,171.268127 C406.334994,164.796373 406.317668,158.2744 406.948279,151.799205 L407,151.268127 C407.572065,145.39409 412.412522,140.855768 418.311199,140.662958 Z"
					id="Rectangle"
					:fill="fill"
				></path>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			ddefault: "",
		},
		width: {
			type: Number,
			default: 272,
		},
		height: {
			type: Number,
			default: 44,
		},
		fill: {
			type: String,
			default: "#FFF",
		},
	},
};
</script>

<style scoped>
path {
	transition: all 0.3s;
}
</style>
